<template>
    <button
        type="button"
        role="button"
        :class="[type, { disabled: disabled }]"
        :disabled="disabled"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'primary',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
button {
    border: 1px solid #c95227;
    border-radius: 4px;
    height: 48px;
    line-height: 46px;
    padding-left: 40px;
    padding-right: 40px;
    text-transform: uppercase;
    white-space: nowrap;
    font-weight: 600;
    font-size: 18px;
    letter-spacing: 1px;
    transition: background-color 0.3s ease;
    position: relative;

    &.primary {
        border-color: #c95227;
        background-color: #c95227;
        color: #fff;

        &:hover {
            background-color: #4e3a30;
            border-color: #4e3a30;
        }
    }

    &.seamless {
        border: 0;
        background-color: transparent;
        height: 20px;
        line-height: 20px;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 700;
        padding: 0;
    }

    &.blue {
        color: #004ecb;
        border-color: #004ecb;

        &:hover {
            color: #002766;
            border-color: #002766;
        }
    }

    &.outline {
        border-color: #c95227;
        background-color: transparent;
        color: #c95227;

        &:hover {
            color: #4e3a30;
        }
    }

    &.outline-fine {
        border-color: #dcd8d6;
        color: #4e3a30;
        background-color: transparent;
        text-transform: none;
        height: 56px;

        &:hover,
        &.active {
            border-color: #c95227;
        }
    }

    &.disabled {
        pointer-events: none;
        &.primary {
            background-color: #dea893;
            border-color: #dea893;
        }
    }

    // !TODO remove when conflict resolved
    &.text-sm {
        font-size: 14px;
    }

    &.text-lg {
        font-size: 18px;
    }
}
</style>
